var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 7.9992L4.87516 0.207553C4.74271 0.074375 4.56279 0 4.37436 0H0.832713C0.546536 0 0.287286 0.172125 0.178213 0.437053L8.49924 8.5L0.177996 16.401C-0.0245761 16.6036 0.0684106 16.2981 0.178213 16.5629C0.287286 16.8279 0.546536 17 0.832713 17H4.37439C4.56282 17 4.74271 16.9256 4.87519 16.7924L12.6669 9.00077C12.9438 8.72382 12.9438 8.27618 12.6668 7.9992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationSurvey);
export default __webpack_public_path__ + "static/media/pagination_survey.d292267dfdd414d1e198478a4f74c8ea.svg";
export { ForwardRef as ReactComponent };